import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { styled } from 'theme';
import { fadeIn } from 'theme/animations';
import { zIndices } from 'theme/constants';

/**
 * Styled Radix UI DropdownMenu components.
 */

const MenuList = styled(DropdownMenu.Content, {
  position: 'relative',
  py: '$2',
  minWidth: '192px',
  backgroundColor: '$white',
  border: '1px solid $border1',
  borderRadius: '$md',
  boxShadow: '$popOver',
  animation: `${fadeIn} 400ms ease`,
  zIndex: zIndices.popOver,
});

const MenuItem = styled(DropdownMenu.Item, {
  display: 'flex',
  alignItems: 'center',
  fontSize: '$sm',
  letterSpacing: '$wide',
  px: '$3',
  py: '$2',
  cursor: 'pointer',
  outline: 'none',
  transition: 'all 200ms ease',
  svg: {
    mr: '$2',
    transition: 'all 200ms ease',
  },
  // Radix marks the actively-navigated item with data-highlighted, where Reach
  // used data-selected.
  '&[data-highlighted]': {
    backgroundColor: '$violet100',
    color: '$violet900',
  },
});

const Menu = DropdownMenu.Root;
const MenuButton = DropdownMenu.Trigger;
const MenuPortal = DropdownMenu.Portal;

export { Menu, MenuList, MenuItem, MenuButton, MenuPortal };
